
export class Banner {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.$root = jQuery(`.js-${this.id}`);
		this.$banner_close_el = this.$root.find(`.js-${this.id}_close`);
		this.$banner_cta = this.$root.find(`.js-${this.id}_cta`);
	}
	init() {
		this.$banner_cta.on('click', this.cta_click);
		this.$banner_close_el.on('click', (e) => {
			
			e.stopPropagation();
			this.close();
		});
	}
	show() {
		yalwa.basics.show(this.$root);
	}
	close() {
		yalwa.basics.hide(this.$root);
	}
	cta_click() {
		//TODO
	}
}